export default __webpack_public_path__ + "static/media/pagination-right-arrow.e53bc7f4.svg";